// Relevant signature type codes. Other options are
// portal - 1
// email - 2
// paper - 3
// oral agreement - 5

import {featureEnabled} from '~/helpers/features';

export const CONTRACT_SIGNATURE_TYPE_CODE_TABLET = 4
export const CONTRACT_SIGNATURE_TYPE_CODE_BANKID = 6

export const PRICE_LIST_ALLOCATION_CODE_DYNAMIC = 1
export const PRICE_LIST_ALLOCATION_CODE_STATIC = 2

export const MIN_FORESTFUND_RATE = 4
export const DEFAULT_FORESTFUND_RATE = 15
export const MAX_FORESTFUND_RATE = 40

export const CONTRACT_FIELD_COLLECTIONPOINT_LENGT_MIN = 3
export const CONTRACT_FIELD_COLLECTIONPOINT_LENGTH_MAX = 40

export const CONTRACT_TYPE_FOREST_OPERATION = 1
export const CONTRACT_TYPE_SILVICULTURE_ORDER = 2
export const CONTRACT_TYPE_REGISTRATION = 3
export const CONTRACT_TYPE_SUPPLY_WOOD = 4
export const CONTRACT_TYPE_SILVICULTURE_AGREEMENT = 5

export const CONTRACT_TYPES = [
  {
    Id: CONTRACT_TYPE_FOREST_OPERATION,
    Name: 'TYPE_FOREST_OPERATION'
  },
  {
    Id: CONTRACT_TYPE_SILVICULTURE_ORDER,
    Name: 'TYPE_SILVICULTURE_ORDER'
  },
  {
    Id: CONTRACT_TYPE_REGISTRATION,
    Name: 'TYPE_REGISTRATION'
  },
  {
    Id: CONTRACT_TYPE_SUPPLY_WOOD,
    Name: 'TYPE_SUPPLY_WOOD'
  },
  {
    Id: CONTRACT_TYPE_SILVICULTURE_AGREEMENT,
    Name: 'TYPE_SILVICULTURE_AGREEMENT'
  }
]

export const CONTRACT_TYPES_ICONS = [
  {
    Id: CONTRACT_TYPE_FOREST_OPERATION,
    Name: 'spot/felling'
  },
  {
    Id: CONTRACT_TYPE_SILVICULTURE_ORDER,
    Name: 'spot/large/silviculture'
  },
  {
    Id: CONTRACT_TYPE_SILVICULTURE_AGREEMENT,
    Name: 'spot/large/silviculture'
  },
  {
    Id: CONTRACT_TYPE_REGISTRATION,
    Name: 'spot/felling'
  },
  {
    Id: CONTRACT_TYPE_SUPPLY_WOOD,
    Name: 'spot/felling'
  }
]

export const CONTRACT_PERIODS = [
  {
    Id: 1,
    Name: 'PERIOD_WINTER'
  },
  {
    Id: 2,
    Name: 'PERIOD_SPRING'
  },
  {
    Id: 3,
    Name: 'PERIOD_SUMMER'
  },
  {
    Id: 4,
    Name: 'PERIOD_FALL'
  }
]

export const CONTRACT_COMPLETIONS = [
  {
    Id: 1,
    Name: 'COMPLETION_AGREED_VOLUME'
  },
  {
    Id: 2,
    Name: 'COMPLETION_AGREED_AREA'
  }
]

export const CONTRACT_OPERATION_COST_TYPE = [
  {
    value: 1,
    text: 'OPERATION_PRICE_FIXED_PRICE_SHORT',
    subText: 'KR_M_UNDER_BARK',
    key: '1'
  },
  {
    value: 2,
    text: 'OPERATION_PRICE_SUGGESTED_RETAIL_SHORT',
    subText: 'KR_M_UNDER_BARK',
    key: '2'
  },
  {
    value: 3,
    text: 'HOURLY_ASSIGNMENTS',
    key: '3'
  }
]

const featureEnvironmentReportForSupplyWoodEnabled = featureEnabled(import.meta.env.FEATURE_ENVIRONMENT_REPORT_FOR_SUPPLY_WOOD)
export const CONTRACT_TYPE_STEPS = [
  {
    Type: CONTRACT_TYPE_FOREST_OPERATION,
    Steps: [
      {
        Step: 1,
        Page: 'loggingperiod',
        Title: 'LOGGING_PERIOD'
      }, {
        Step: 2,
        Page: 'actionplans',
        Title: 'ACTIONPLANS_TITLE'
      }, {
        Step: 3,
        Page: 'environmentreport',
        Title: 'ENVIRONMENT_REPORT'
      }, {
        Step: 4,
        Page: 'additions',
        Title: 'ADDITIONS'
      }, {
        Step: 5,
        Page: 'volumeAndEntrepreneur',
        Title: 'VOLUME_ENTREPRENEUR'
      }, {
        Step: 6,
        Page: 'assortments',
        Title: 'ASSORTMENTS'
      }, {
        Step: 7,
        Page: 'prices',
        Title: 'PRICES'
      }, {
        Step: 8,
        Page: 'toppleplaces',
        Title: 'COLLECTION_PLACE'
      }, {
        Step: 9,
        Page: 'agreement',
        Title: 'FOREST_REMOVAL_MISSION'
      }, {
        Step: 10,
        Page: 'silviculture',
        Title: 'SILVICULTURE'
      }, {
        Step: 11,
        Page: 'finaldetails',
        Title: 'FINAL_DETAILS'
      }, {
        Step: 12,
        Page: 'summary',
        Title: 'SUMMARY'
      }, {
        Step: 13,
        Page: 'details',
        Title: 'DETAILS'
      }, {
        Step: 14,
        Page: 'sign',
        Title: 'SIGN'
      }, {
        Step: 15,
        Page: 'finish',
        Title: 'FINISH'
      }
    ]
  },
  {
    Type: CONTRACT_TYPE_SILVICULTURE_ORDER,
    Steps: [
      {
        Step: 1,
        Page: 'actionplans',
        Title: 'ACTIONPLANS_TITLE'
      }, {
        Step: 2,
        Page: 'silviculture',
        Title: 'SILVICULTURE'
      }, {
        Step: 3,
        Page: 'finaldetails',
        Title: 'FINAL_DETAILS'
      }, {
        Step: 4,
        Page: 'details',
        Title: 'DETAILS'
      }
    ]
  },
  {
    Type: CONTRACT_TYPE_SILVICULTURE_AGREEMENT,
    Steps: [
      {
        Step: 1,
        Page: 'loggingperiod',
        Title: 'PERIOD'
      },
      {
        Step: 2,
        Page: 'actionplans',
        Title: 'ACTIONPLANS_TITLE'
      },
      {
        Step: 3,
        Page: 'location',
        Title: 'LOCATION_NAME'
      },
      {
        Step: 4,
        Page: 'environmentreport',
        Title: 'ENVIRONMENT_CONSIDERATION'
      },
      {
        Step: 5,
        Page: 'details',
        Title: 'DETAILS'
      },
      {
        Step: 6,
        Page: 'silvicultureSummary',
        Title: 'SUMMARY'
      },
      {
        Step: 7,
        Page: 'sign',
        Title: 'SIGN'
      }, {
        Step: 8,
        Page: 'finish',
        Title: 'FINISH'
      }
    ]
  },
  {
    Type: CONTRACT_TYPE_REGISTRATION,
    Steps: [
      {
        Step: 1,
        Page: 'loggingperiod',
        Title: 'LOGGING_PERIOD'
      },
        {
            Step: 2,
            Page: 'actionplans',
            Title: 'ACTIONPLANS_TITLE'
        },
        {
        Step: 3,
        Page: 'volumeAndEntrepreneur',
        Title: 'VOLUME_ENTREPRENEUR'
      }, {
        Step: 4,
        Page: 'assortments',
        Title: 'ASSORTMENTS'
      }, {
        Step: 5,
        Page: 'prices',
        Title: 'PRICES'
      }, {
        Step: 6,
        Page: 'toppleplaces',
        Title: 'COLLECTION_PLACE'
      }, {
        Step: 7,
        Page: 'agreement',
        Title: 'FOREST_REMOVAL_MISSION'
      }, {
        Step: 8,
        Page: 'finaldetails',
        Title: 'FINAL_DETAILS'
      }, {
        Step: 9,
        Page: 'details',
        Title: 'DETAILS'
      }
    ]
  },
  {
    Type: CONTRACT_TYPE_SUPPLY_WOOD,
    Steps: [
      {
        Step: 1,
        Page: 'loggingperiod',
        Title: 'LOGGING_PERIOD'
      }, {
        Step: 2,
        Page: 'actionplans',
        Title: 'ACTIONPLANS_TITLE'
      }, {
        Step: 3,
        Page: featureEnvironmentReportForSupplyWoodEnabled ? 'environmentreport' : 'environmentcheck',
        Title: 'DUE_DILIGENCE_ASSESSMENT'
      }, {
        Step: 4,
        Page: 'volumeAndEntrepreneur',
        Title: 'VOLUME_ENTREPRENEUR'
      }, {
        Step: 5,
        Page: 'assortments',
        Title: 'ASSORTMENTS'
      }, {
        Step: 6,
        Page: 'prices',
        Title: 'PRICES'
      }, {
        Step: 7,
        Page: 'toppleplaces',
        Title: 'COLLECTION_PLACE'
      }, {
        Step: 8,
        Page: 'agreement',
        Title: 'FOREST_REMOVAL_MISSION'
      }, {
        Step: 9,
        Page: 'silviculture',
        Title: 'SILVICULTURE'
      }, {
        Step: 10,
        Page: 'finaldetails',
        Title: 'FINAL_DETAILS'
      }, {
        Step: 11,
        Page: 'summary',
        Title: 'SUMMARY'
      }, {
        Step: 12,
        Page: 'sign',
        Title: 'SIGN'
      }, {
        Step: 13,
        Page: 'finish',
        Title: 'FINISH'
      }
    ]
  }
]

export const NEW_CONTRACT_OPTIONS = [
  {
    key: 'forestoperation',
    value: CONTRACT_TYPE_FOREST_OPERATION,
    text: 'TYPE_FOREST_OPERATION',
    subText: 'TYPE_FOREST_OPERATION_DESC',
    icon: 'spot/large/felling'
  }, {
    key: 'supplywood',
    value: CONTRACT_TYPE_SUPPLY_WOOD,
    text: 'TYPE_SUPPLY_WOOD',
    subText: 'TYPE_SUPPLY_WOOD_DESC',
    icon: 'spot/large/mill'
  },
  {
    key: 'silvicultureagreement',
    value: CONTRACT_TYPE_SILVICULTURE_AGREEMENT,
    text: 'TYPE_SILVICULTURE_AGREEMENT',
    subText: 'TYPE_SILVICULTURE_AGREEMENT_DESC',
    icon: 'spot/large/silviculture'
  },
  {
    key: 'silvicultureorder',
    value: CONTRACT_TYPE_SILVICULTURE_ORDER,
    text: 'TYPE_SILVICULTURE_ORDER',
    subText: 'TYPE_SILVICULTURE_ORDER_DESC',
    icon: 'spot/large/silviculture'
  },
  {
    key: 'registration',
    value: CONTRACT_TYPE_REGISTRATION,
    text: 'TYPE_REGISTRATION',
    subText: 'TYPE_REGISTRATION_DESC',
    icon: 'spot/large/transport'
  },
]

export const NEW_CONTRACT_TYPE_OPTIONS = [
  {
    key: 'forestoperation',
    value: CONTRACT_TYPE_FOREST_OPERATION,
    text: 'Vanlig driftsavtale',
    subText: 'Glommen Mjøsen håndterer drift, sertifisering og foryngelse'
  }, {
    key: 'registration',
    value: CONTRACT_TYPE_REGISTRATION,
    text: 'Innmelding',
    subText: 'Glommen Mjøsen håndterer transport og salg'
  }, {
    key: 'supplywood',
    value: CONTRACT_TYPE_SUPPLY_WOOD,
    text: 'Leveransevirke',
    subText: 'Glommen Mjøsen håndterer salg'
  }
]

export const SILVI_CULTURE = [
  {
    Name: 'IS_GROUND_PREPARED',
    Field: 'IsGroundPrepared',
    Required: false
  },
  {
    Name: 'SKID_ROAD',
    Field: 'SkidRoad',
    Required: false
  },
  {
    Name: 'ENVIRONMENTAL_CONDITIONS',
    Field: 'EnvironmentalConditions',
    Required: false
  },
  {
    Name: 'OPERATION_ROAD_LENGTH',
    Field: 'OperationRoadLength500',
    Required: false
  },
  {
    Name: 'FALL_PLANTING',
    Field: 'FallPlanting',
    Required: false
  },
  {
    Name: 'BARRIER_KEYS',
    Field: 'BarrierKeys',
    Required: false
  },
  {
    Name: 'FOREST_OWNER_TRANSPORTS_PLANTS',
    Field: 'ForestOwnerTransportsPlants',
    Required: false
  },
  {
    Name: 'NEED_YOUNG_FOREST_CARE_ASSESSED_ON_PROPERTY',
    Field: 'NeedYoungForestCareAssessedOnProperty',
    Required: true,
    Group: 'YOUNG_FOREST_CARE'
  },
  {
    Name: 'NEED_YOUNG_FOREST_CARE',
    Field: 'NeedYoungForestCare',
    Required: true,
    Group: 'YOUNG_FOREST_CARE'
  },
  {
    Name: 'PLAN_IMPLEMENTATION_OF_YOUNG_FOREST_CARE',
    Field: 'PlanImplementationOfYoungForestCare',
    Required: true,
    Group: 'YOUNG_FOREST_CARE'
  }
]

/**
 * Contract activation wait time after making changes that need syncing
 */
export const MS_DELAY_CRM_TO_VH_SYNC = 1000 /*ms*/ * 90 /*seconds*/

/** Interval for running cleanup-routine, clearing old entries */
export const MS_INTERVAL_CLEAN_MODIFIED_TIMESTAMPS = 1000 /*ms*/ * 60 /*seconds*/ * 5 /*minutes*/

